<template>
  <div class="pm-list">
    <div class="pm-container">
      <div class="pm-head">
        <span @click="titleClick">{{ reactTitle }}</span>
        <i @click="triggleIcon" class="envTab_icon" :class="reactClass"></i>
      </div>
      <div class="pm-body">
        <div
          v-for="(item, index) in reactData"
          :key="index"
          class="pm-body-item"
          @click="envLiClick(item, index)"
        >
          <div class="index">{{ index + 1 }}</div>
          <div class="name">{{ item.Equipment_Name }}</div>
          <div class="value">
            {{ dataIndex ? item.PM10 : item.PM25 }}
            <i style="color: #a6caff">μg/m³</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["matrix", "x", "y"],
  computed: {
    reactTitle() {
      if (!this.dataIndex) {
        return "PM25";
      } else {
        return "PM10";
      }
    },
    reactClass() {
      if (!this.singnType) {
        return "";
      } else {
        return "envTab_icon_active";
      }
    },
    reactData() {
      if (this.dataIndex) {
        return this.dataEnvList10;
      } else {
        return this.dataEnvList25;
      }
    },
  },
  data() {
    return {
      //环境排行榜
      dataEnvList: [],
      dataEnvList25: [],
      dataEnvList10: [],

      dataIndex: 0,
      singnType: 0,
      type: "PM25",
      timer: null,
    };
  },
  created() {},
  mounted() {
    //一分钟刷一下
    setInterval(() => {
      //环境排行
      this.envRankData();
    }, 30000);
    setTimeout(() => {
      this.envRankData();
      //暂时注释
      //				this.layerFun();
    }, 5000);
    let that = this;
    let w = $(that.$refs.shedListBar).outerWidth();
    let h = $(that.$refs.shedListBar).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
  },
  methods: {
    envRankData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.dataEnvList = window.g_bme3dManager?.krigingsManager
        ._currentRealTimeData
        ? window.g_bme3dManager.krigingsManager._currentRealTimeData
        : this.dataEnvList;
      if (this.dataEnvList.length) {
        this.dataEnvList.forEach((x, i) => {
          x.sort = i; //添加字段sort 用于图标扩大效果
        });
        this.dataEnvList = this.paixu(
          this.dataEnvList,
          this.type,
          this.signType
        );
        this.dataEnvList.forEach((x, i) => {
          if (isNaN(parseFloat(x.PM25))) {
            x.envColor25 = "rgb(253,253,253)";
          } else if (parseFloat(x.PM25) < 75) {
            x.envColor25 = "#00FF00";
          } else if (75 <= parseFloat(x.PM25) && parseFloat(x.PM25) <= 150) {
            x.envColor25 = "rgb(251,254,84)";
          } else {
            x.envColor25 = "rgb(255,130,0)";
          }

          if (isNaN(parseFloat(x.PM10))) {
            x.envColor10 = "rgb(253,253,253)";
          } else if (parseFloat(x.PM10) < 150) {
            x.envColor10 = "#00FF00";
          } else if (150 <= parseFloat(x.PM10) && parseFloat(x.PM10) <= 350) {
            x.envColor10 = "rgb(251,254,84)";
          } else {
            x.envColor10 = "rgb(255,130,0)";
          }
        });

        this.dataEnvList25 = [];
        this.dataEnvList.forEach((x, i) => {
          this.dataEnvList25.push(x);
        });

        this.dataEnvList10 = [];
        this.dataEnvList.forEach((x, i) => {
          this.dataEnvList10.push(x);
        });
      } else {
        this.timer = setTimeout(() => this.envRankData(), 1000);
      }
    },
    paixu(data, type, signType) {
      if (!signType) {
        data.sort(function (a, b) {
          //  			console.log(a[type] == '--')
          if (a[type] == "--") {
            return -1;
          } else {
            return b[type] - a[type];
          }
        });
        // data.reverse()
      } else {
        data.sort(function (a, b) {
          if (a[type] == "--") {
            return -1;
          } else {
            return a[type] - b[type];
          }
        });
      }
      return data;
    },
    triggleIcon() {
      if (!this.singnType) {
        this.singnType = 1;
      } else {
        this.singnType = 0;
      }
      if(this.dataIndex) {
        this.reactData = this.paixu(this.dataEnvList10, 'PM10', this.singnType);
      } else {
        this.reactData = this.paixu(this.dataEnvList25, 'PM25', this.singnType);
      }
    },
    titleClick() {
      if (this.dataIndex) {
        this.type = "PM25";
        this.dataIndex = 0;
      } else {
        this.type = "PM10";
        this.dataIndex = 1;
      }
    },
    envLiClick(item, i) {
      let sn_index = 0
      this.li_active_index = i
      this.changeTitlePm()
      g_bme3dManager.krigingsManager._poisCollection.PM25._entites.find((x, index) => {
        if (x._xbsjGuid == item.SN) {
          sn_index = index
        }
      })
      g_bme3dManager.earth.camera.flyTo(
        [(item.longitude * Math.PI) / 180.0, (item.latitude * Math.PI) / 180.0, g_bmeConfig.config.poi.height],
        1500,
        undefined,
        2
      )
      //图标放大
      //if(this.customerId !== 8){
      let time = 3000
      for (var i = 0; i < 4; i++) {
        setTimeout(() => {
          let qgScale = this.customerId !== 8 ? 1 : 0.8
          if (this.dataIndex == 0) {
            //pm25
            g_bme3dManager.krigingsManager._poisCollection.PM25._entites[sn_index].billboard.scale = 1.4
            g_bme3dManager.krigingsManager._poisCollection.PM25._entites[sn_index].label.scale = 0.4 //初始为.25
            g_bme3dManager.krigingsManager._poisCollection.PM25._entites[sn_index].label.pixelOffset._value.y = -150 * qgScale
          } else {
            //pm10
            g_bme3dManager.krigingsManager._poisCollection.PM10._entites[sn_index].billboard.scale = 1.4
            g_bme3dManager.krigingsManager._poisCollection.PM10._entites[sn_index].label.scale = 0.4
            g_bme3dManager.krigingsManager._poisCollection.PM10._entites[sn_index].label.pixelOffset._value.y = -150 * qgScale
          }
        }, time + 1000 * i)
        setTimeout(() => {
          let qgScale = this.customerId !== 8 ? 1 : 0.8
          if (this.dataIndex == 0) {
            //pm25
            g_bme3dManager.krigingsManager._poisCollection.PM25._entites[sn_index].billboard.scale = 0.8 //pois.js里设置了
            g_bme3dManager.krigingsManager._poisCollection.PM25._entites[sn_index].label.scale = 0.25 //初始为.25
            g_bme3dManager.krigingsManager._poisCollection.PM25._entites[sn_index].label.pixelOffset._value.y = -80 * qgScale
          } else {
            //pm10
            g_bme3dManager.krigingsManager._poisCollection.PM10._entites[sn_index].billboard.scale = 0.8
            g_bme3dManager.krigingsManager._poisCollection.PM10._entites[sn_index].label.scale = 0.25
            g_bme3dManager.krigingsManager._poisCollection.PM10._entites[sn_index].label.pixelOffset._value.y = -80 * qgScale
          }
        }, time + 500 + 1000 * i)
      }
      //}
    },
    changeTitlePm() {
      //传值
      if (this.dataIndex == 0) {
        //  		this.$store.state.app.titlePm10=!this.$store.state.app.titlePm10;
        let titlePm25 = !this.$store.state.titlePm25
        this.$store.commit('updateTitlePm25', { titlePm25 })
      } else {
        let titlePm10 = !this.$store.state.titlePm10
        this.$store.commit('updateTitlePm10', { titlePm10 })
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.pm {
  &-list {
    position: absolute;
    width: 600px;
    height: 790px;
  }
  &-container {
    width: 100%;
    height: 100%;
    padding-top: 30px;
  }
  &-head {
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 30px;
    text-shadow: 8px 8px 8px rgb(255 255 255 / 50%);
    font-family: "workOrderFont";
    cursor: pointer;
  }
  &-body {
    height: calc(100% - 50px);
    border: 1px solid rgb(2, 45, 64, 0.8);
    overflow: scroll;
    &-item {
      min-height: 50px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    //   background-color: rgb(2, 45, 64, 0.8);
      margin-bottom: 5px;
      cursor: pointer;
      .index {
        color: #00fcff;
      }
      .name {
        font-size: 20px;
        flex: 2;
        text-align: left;
        margin-left: 50px;
        font-family: "workOrderFont";
      }
      .value {
        color: rgb(0, 255, 0);
      }
    }
  }
}
.envTab_icon {
  cursor: pointer;
  margin-left: 10px;
  display: inline-block;
  width: 10px;
  height: 16px;
  background-image: url("./img/icon_rank_selected.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.envTab_icon_active {
  cursor: pointer;
  margin-left: 10px;
  display: inline-block;
  width: 10px;
  height: 16px;
  background-image: url("./img/icon_rank_selected2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.pm-body-item:hover {
    background-color: rgb(2, 45, 64, 0.8);
}
</style>